import React from 'react';
import IconTooltipModal from '../../components/ui/IconTooltipModal';
import SvgIcon from '../../utils/SvgIcon';
import ImageCarousel from './ImageCarousel';
import type { GetServiceImagesResponse } from '../../types/service-images';

type ImagesModalProps = Readonly<{
  row: Record<string, any>;
  listingType: string;
}>;

export default function ImagesModal({ row }: ImagesModalProps) {
  const loadImage = async (): Promise<string[] | null> => {
    const jobId = row.guid as string;

    const jobImageCount = Number(row.jobImageCount) || 0;
    const weighingImageCount = Number(row.weighingImageCount) || 0;
    const routeVisitImageCount = Number(row.routeVisitImageCount) || 0;

    const weighingId = row.weighingId as string | undefined;
    const routeVisitId = row.routeVisitId as string | undefined;

    // Build query params
    const query = new URLSearchParams();

    query.set('jobImageCount', jobImageCount.toString());
    query.set('weighingImageCount', weighingImageCount.toString());
    query.set('routeVisitImageCount', routeVisitImageCount.toString());

    if (weighingId) {
      query.set('weighingId', weighingId);
    }

    if (routeVisitId) {
      query.set('routeVisitId', routeVisitId);
    }

    const res = await fetch(`/api/downloads/images/${jobId}?${query}`);

    if (!res.ok) {
      console.error('Failed to fetch images', await res.text());
      return null;
    }

    const data = (await res.json()) as GetServiceImagesResponse;

    return [...(data.jobImageUrls ?? []), ...(data.weighingImageUrls ?? []), ...(data.routeVisitImageUrls ?? [])];
  };

  // Count total image groups
  const jobCount = Number(row.jobImageCount) || 0;
  const weighingCount = Number(row.weighingImageCount) || 0;
  const routeCount = Number(row.routeVisitImageCount) || 0;

  const totalImageCount = jobCount + weighingCount + routeCount;

  if (totalImageCount === 0) {
    return null;
  }

  return (
    <IconTooltipModal
      tooltip="Open images"
      triggerAriaLabel="Open Images"
      triggerIcon={
        <SvgIcon iconName="media-image" additionalClasses="tooltip-icon-trigger-images-icon" viewBox="0 0 24 24" />
      }
      modalTitle="Images"
      modalClassName="modal--portal-docs"
      dialogClassName="modal__content--portal-docs"
      closeAriaLabel="Close"
    >
      <ImageCarousel imageLoader={loadImage} />
    </IconTooltipModal>
  );
}
